import { render, staticRenderFns } from "./WorkshopItem.vue?vue&type=template&id=1d3568c4&scoped=true&"
import script from "./WorkshopItem.vue?vue&type=script&lang=js&"
export * from "./WorkshopItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopItem.vue?vue&type=style&index=0&id=1d3568c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3568c4",
  null
  
)

export default component.exports